export default "/img/GR.15c0df1305bddd563a410635e8bbb295.png";